import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-start items-start space-y-3 list-disc px-[7%]" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }

import informace from "../../../public/data/informace";
// const informations = [
//   {
//     date: '25.8.2023',
//     link: '/data/informace/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '12.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Prohlášení o bezinfekčnosti',
//   },
//   {
//     date: '1.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Soustředění Bystřice pod Hostýnem, Ústí nad Orlicí a Vyškov',
//   },
//   {
//     date: '9.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '1.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Tréninky do akademie',
//   },
//   {
//     date: '25.8.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '25.8.2023',
//     link: '/data/informace/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '12.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Prohlášení o bezinfekčnosti',
//   },
//   {
//     date: '1.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Soustředění Bystřice pod Hostýnem, Ústí nad Orlicí a Vyškov',
//   },
//   {
//     date: '9.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '1.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Tréninky do akademie',
//   },
//   {
//     date: '25.8.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '25.8.2023',
//     link: '/data/informace/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '12.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Prohlášení o bezinfekčnosti',
//   },
//   {
//     date: '1.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Soustředění Bystřice pod Hostýnem, Ústí nad Orlicí a Vyškov',
//   },
//   {
//     date: '9.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '1.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Tréninky do akademie',
//   },
//   {
//     date: '25.8.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '25.8.2023',
//     link: '/data/informace/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '12.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Prohlášení o bezinfekčnosti',
//   },
//   {
//     date: '1.6.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Soustředění Bystřice pod Hostýnem, Ústí nad Orlicí a Vyškov',
//   },
//   {
//     date: '9.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   },
//   {
//     date: '1.5.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: 'Tréninky do akademie',
//   },
//   {
//     date: '25.8.2023',
//     link: '/Vyskovsky pohar - vysledky.pdf',
//     title: null,
//   }
// ]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(informace), (info) => {
      return (_openBlock(), _createElementBlock("li", {
        key: info.date,
        class: "text-left"
      }, [
        _createElementVNode("span", null, _toDisplayString(info.date) + " -", 1),
        _createElementVNode("a", {
          href: 'PDFs/informace/' + info.pdf,
          target: "_blank",
          class: "text-green underline"
        }, " Informace ", 8, _hoisted_2),
        (info.description !== null && info.description !== '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " - " + _toDisplayString(info.description), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})